// Components==============
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import './SharecodeInput.module.scss';
// =========================

export default function SharecodeInput({
  handleSubmit,
}: {
  handleSubmit: (val: string) => void;
}) {
  const [value, setValue] = useState('');

  function handleLocalSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    handleSubmit(value);
    setValue('');
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
  }

  return (
    <form onSubmit={handleLocalSubmit} styleName="sharecode-input">
      <input placeholder="sharecode" onChange={handleChange} value={value} />
      <button type="submit" styleName="arrow">
        <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </form>
  );
}
